__webpack_require__.p = "https://qa.knowledgesearchcore.thomsonreuters.com/";